import { BoardListPositionSelectSkeleton } from './BoardListPositionSelectSkeleton';

import styles from './CopyCardPopoverSkeleton.less';

export const CopyCardPopoverSkeleton = () => {
  return (
    <div>
      <div className={styles.skeletonHeaderText} />
      <div className={styles.skeletonTitleInput} />
      <BoardListPositionSelectSkeleton />
    </div>
  );
};
